"use strict";

exports.__esModule = true;
exports.default = chainResult;
var _underscore = _interopRequireDefault(require("./underscore.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? (0, _underscore.default)(obj).chain() : obj;
}